/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmMatchingPolicySummaryDto
 */
export interface MdmMatchingPolicySummaryDto {
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicySummaryDto
     */
    configurationId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicySummaryDto
     */
    policyId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicySummaryDto
     */
    assetClass?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicySummaryDto
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicySummaryDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicySummaryDto
     */
    policyVersionLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchingPolicySummaryDto
     */
    configurationVersion?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MdmMatchingPolicySummaryDto
     */
    activeForAssetClass?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchingPolicySummaryDto
     */
    ruleCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchingPolicySummaryDto
     */
    autoMergesLast7Days?: number;
    /**
     * 
     * @type {Date}
     * @memberof MdmMatchingPolicySummaryDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicySummaryDto
     */
    updatedBy?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MdmMatchingPolicySummaryDto
     */
    legacySystemDefault?: boolean;
}

/**
 * Check if a given object implements the MdmMatchingPolicySummaryDto interface.
 */
export function instanceOfMdmMatchingPolicySummaryDto(value: object): value is MdmMatchingPolicySummaryDto {
    return true;
}

export function MdmMatchingPolicySummaryDtoFromJSON(json: any): MdmMatchingPolicySummaryDto {
    return MdmMatchingPolicySummaryDtoFromJSONTyped(json, false);
}

export function MdmMatchingPolicySummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmMatchingPolicySummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'configurationId': json['configurationId'] == null ? undefined : json['configurationId'],
        'policyId': json['policyId'] == null ? undefined : json['policyId'],
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'status': json['status'] == null ? undefined : json['status'],
        'policyVersionLabel': json['policyVersionLabel'] == null ? undefined : json['policyVersionLabel'],
        'configurationVersion': json['configurationVersion'] == null ? undefined : json['configurationVersion'],
        'activeForAssetClass': json['activeForAssetClass'] == null ? undefined : json['activeForAssetClass'],
        'ruleCount': json['ruleCount'] == null ? undefined : json['ruleCount'],
        'autoMergesLast7Days': json['autoMergesLast7Days'] == null ? undefined : json['autoMergesLast7Days'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'legacySystemDefault': json['legacySystemDefault'] == null ? undefined : json['legacySystemDefault'],
    };
}

export function MdmMatchingPolicySummaryDtoToJSON(json: any): MdmMatchingPolicySummaryDto {
    return MdmMatchingPolicySummaryDtoToJSONTyped(json, false);
}

export function MdmMatchingPolicySummaryDtoToJSONTyped(value?: MdmMatchingPolicySummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'configurationId': value['configurationId'],
        'policyId': value['policyId'],
        'assetClass': value['assetClass'],
        'displayName': value['displayName'],
        'status': value['status'],
        'policyVersionLabel': value['policyVersionLabel'],
        'configurationVersion': value['configurationVersion'],
        'activeForAssetClass': value['activeForAssetClass'],
        'ruleCount': value['ruleCount'],
        'autoMergesLast7Days': value['autoMergesLast7Days'],
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'updatedBy': value['updatedBy'],
        'legacySystemDefault': value['legacySystemDefault'],
    };
}

